import moment from "moment"
import EChartsController from "../echarts_controller"

export default class extends EChartsController {
  static values = {
    report: { type: Object, default: {} },
  }

  chartTargetConnected(target) {
    super.chartTargetConnected(target)

    const startDate = moment.utc(target.dataset.startDate).toDate()
    const endDate = moment.utc(target.dataset.endDate).toDate()
    this.renderChart(this.chart, this.reportValue, startDate, endDate)
  }

  renderChart(chart, report, start_date, end_date) {
    const {
      first_blocked_at,
      first_predicted_at,
      first_protected_at,
      activity,
    } = report

    const groupByWeek = (elements) => {
      const formatted = elements.map((elem) => ({
        date: moment.utc(elem[0]).endOf("week").format("YYYY-MM-DD"),
        events: elem[1],
      }))

      const dates = formatted.map((elem) => elem.date)
      const uniqueDates = dates.filter(
        (date, index) => dates.indexOf(date) === index,
      )

      return uniqueDates.map((date) => {
        const count = formatted
          .filter((elem) => elem.date === date)
          .reduce((count, elem) => count + elem.events, 0)
        return { date, count }
      })
    }

    const eventsByWeek = groupByWeek(activity)

    const activityData = eventsByWeek.map(({ date, count }, index) => [
      moment.utc(date).subtract(84, "hours").toDate(), // move activity date to mid week
      count === 0 ? null : count,
    ])

    const tooltipFormatter = (params) => {
      if (params.componentType === "markLine") {
        const { name, value: date } = params.data
        return `${name} ${moment.utc(date).format("MMMM DD, YYYY")}`
      } else if (
        params.componentType === "series" &&
        params.componentSubType === "bar"
      ) {
        const [date, value] = params.data
        return `Week ${moment.utc(date).isoWeek()} Events: ${value}`
      }
    }

    const getOption = () => {
      return {
        useUTC: true,
        tooltip: {
          trigger: "item",
          formatter: tooltipFormatter,
        },
        xAxis: {
          type: "time",
          min: moment.utc(start_date).subtract(1, "week").toDate(),
          max: moment.utc(end_date).add(1, "week").toDate(),
          axisLine: { lineStyle: { color: "#5e7388" } },
          axisLabel: {
            color: "#B6C7D8",
            fontSize: 12,
            formatter: "{MMM} {dd} {yy}",
          },
        },
        yAxis: {
          type: "log",
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        grid: {
          left: "1.5%",
          top: "15%",
          right: "1.5%",
          bottom: "25%",
        },
        series: [
          {
            type: "bar",
            data: activityData,
            symbol: "none",
            itemStyle: {
              color: "#F35C2F",
            },
          },
        ],
      }
    }

    const option = getOption()

    if (first_predicted_at && first_protected_at && first_blocked_at) {
      const first_blocked_date = moment.utc(first_blocked_at).toDate()
      const first_predicted_date = moment.utc(first_predicted_at).toDate()

      if (moment.utc(first_blocked_date).isAfter(first_predicted_date)) {
        option.series.push({
          type: "line",
          markArea: {
            itemStyle: { color: "#19324C" },
            data: [
              [{ xAxis: first_predicted_date }, { xAxis: first_blocked_date }],
            ],
          },
        })
      }
    }

    if (first_predicted_at) {
      const first_predicted_date = moment.utc(first_predicted_at).toDate()
      option.series.push({
        type: "line",
        data: [[first_predicted_date, null]],
        markLine: {
          symbol: "circle",
          symbolSize: 15,
          data: [
            {
              name: "First Predicted",
              xAxis: first_predicted_date,
              symbol: "none",
              lineStyle: {
                type: "solid",
                color: "#09D2D2",
              },
              label: {
                show: false,
              },
            },
          ],
        },
      })
    }

    if (first_protected_at) {
      const first_protected_date = moment.utc(first_protected_at).toDate()
      option.series.push({
        type: "line",
        data: [[first_protected_date, null]],
        markLine: {
          symbol:
            "path://M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z",
          symbolSize: 17,
          data: [
            {
              name: "First Protected",
              xAxis: first_protected_date,
              symbol: "none",
              lineStyle: {
                type: "solid",
                color: "#3F83F8",
              },
              label: {
                show: false,
              },
            },
          ],
        },
      })
    }

    if (first_blocked_at) {
      const first_blocked_date = moment.utc(first_blocked_at).toDate()
      option.series.push({
        type: "line",
        data: [[first_blocked_date, null]],
        markLine: {
          symbol: "rect",
          symbolSize: 16,
          data: [
            {
              name: "First Blocked",
              xAxis: first_blocked_date,
              symbol: "none",
              lineStyle: {
                type: "solid",
                color: "#10B981",
              },
              label: {
                show: false,
              },
            },
          ],
        },
      })
    }

    chart.setOption(option)
    chart.dispatchAction({
      type: "showTip",
      seriesIndex: 0,
      dataIndex: activityData.length - 1,
    })
  }
}
